import useDappsControllerState from './useDappsControllerState'

export default useDappsControllerState
